(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.zoraw-header-wrapper');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.stickyEnabled = this.stickyType !== 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;

      if (this.stickyEnabled) {
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      } else {
        this.header.classList.remove('sticky');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.hideHeaderOnScrollUp) {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      }
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyType = this.getAttribute('data-sticky-type');
      const threshold = 100;

      if (stickyType === 'none') {
        this.header.classList.remove('sticky');
        return;
      }

      if (stickyType === 'always' || stickyType === 'reduce-logo-size') {
        if (scrollTop > threshold) {
          this.header.classList.add('sticky');
        } else {
          this.header.classList.remove('sticky');
        }
      } else if (stickyType === 'on-scroll-up') {
        if (scrollTop > threshold && scrollTop < this.currentScrollTop) {
          this.header.classList.add('sticky');
        } else if (scrollTop > threshold && scrollTop > this.currentScrollTop) {
          this.header.classList.remove('sticky');
        } else if (scrollTop <= threshold) {
          this.header.classList.remove('sticky');
        }
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoraw-cart-drawer"]) return;
  try {
    
  // Locale-aware root ('/fr/' on the French storefront, '/' otherwise). Cart AJAX
  // endpoints and the ?sections= re-render must be prefixed with this, otherwise
  // the section HTML comes back rendered in the default (English) locale and the
  // drawer "reverts to English" after an add/change on /fr.
  var ZR_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  // This section renders inside the "cart-drawer-group" section group (an
  // aside), not a template's top-level sections list. Shopify assigns those
  // group-rendered sections a dynamic composite id at runtime
  // ("sections--<group-instance>__zoraw-cart-drawer"), which is what actually
  // shows up as section.id / the "shopify-section-*" wrapper id on the page.
  // The cart Section Rendering API (`sections=`) only returns settings-aware
  // HTML when asked for that real id — asking for the bare literal
  // "zoraw-cart-drawer" (which isn't a registered section id anywhere) makes
  // Shopify render the section from its SCHEMA DEFAULTS instead of this
  // instance's saved settings. That silently reintroduced the mystery-gift
  // tier and reset the free-shipping threshold on every add/remove/qty-change
  // re-render, even though the correct settings were saved and the initial
  // page load looked fine. Read the real id from the DOM instead of
  // hardcoding the literal section key.
  var ZR_SECTION_ID = (document.getElementById('zoraw-cart-drawer') && document.getElementById('zoraw-cart-drawer').dataset.sectionId) || 'zoraw-cart-drawer';
  var zorawCart = {
    drawer: document.getElementById('zoraw-cart-drawer'),
    previousFocus: null,
    // Concurrency guards. `_inflight` counts drawer-initiated cart mutations
    // currently in flight; `_seq` increments each time a mutation writes to the
    // DOM. Together they let refresh() bail out when a mutation is authoritative,
    // so a stale full-drawer re-render can't resurrect a just-deleted line item.
    _inflight: 0,
    _seq: 0,
    // Pending close() cleanup timer — cancelled by open() so a rapid
    // close→reopen can't be re-hidden by the stale timer.
    _closeTimer: null,

    // Always resolve the items wrapper from the live DOM. refresh() replaces the
    // drawer's innerHTML, so any cached reference to the <form> goes stale/detached
    // and the `.loading` pointer-events guard would silently apply to a dead node.
    setLoading: function(isLoading) {
      var wrapper = document.querySelector('.zoraw-cart-items-wrapper');
      if (wrapper) wrapper.classList.toggle('loading', !!isLoading);
    },

    init: function() {
      if (window.zorawPendingOpen) {
        window.zorawPendingOpen = false;
        this.open();
      }

      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:refresh', this.refresh.bind(this));

      // Subscribe to Dawn's cart pub/sub so qty changes on /cart (or any
      // other Dawn cart surface) re-render the zoraw drawer. Without this,
      // the drawer keeps showing the bundle "intact" view even after the
      // customer broke the bundle on /cart — they'd have to refresh to see
      // the bundle decomposed into individual products.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
          if (event && event.source === 'zoraw-cart') return;
          zorawCart.refresh();
        });
      }

      // Belt-and-suspenders: also watch fetch() for /cart/* mutations. This
      // catches scenarios where Dawn's pubsub event is missed (script-load
      // timing) and any third-party scripts that hit the cart endpoints
      // directly without going through Dawn's CartItems component.
      // The drawer's own fetches include `sections: 'zoraw-cart-drawer'` in
      // the request body — those already update the drawer DOM themselves,
      // so we skip the redundant refresh in that case.
      if (!window.__zorawFetchPatched) {
        window.__zorawFetchPatched = true;
        var origFetch = window.fetch;
        window.fetch = function(input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var isCartMutation = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url);
          var promise = origFetch.apply(this, arguments);
          if (!isCartMutation) return promise;

          // Inspect body to detect the drawer's own self-fetches.
          var body = init && init.body;
          var isSelf = false;
          if (typeof body === 'string' && body.indexOf('zoraw-cart-drawer') !== -1) {
            isSelf = true;
          } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
            var s = body.get && body.get('sections');
            if (s && String(s).indexOf('zoraw-cart-drawer') !== -1) isSelf = true;
          }
          if (isSelf) return promise;

          promise.then(function(resp) {
            if (resp && resp.ok) {
              setTimeout(function() {
                if (window.zorawCart && typeof window.zorawCart.refresh === 'function') {
                  window.zorawCart.refresh();
                }
              }, 0);
            }
          }).catch(function() {});
          return promise;
        };
      }

      document.body.addEventListener('click', function(e) {
        var addToCartBtn = e.target.closest('button[name="add"]');
        if (addToCartBtn) {
          // Never intercept clicks from the custom multi-flavor buy box (.zrw-fuel-buybox)
          if (
            addToCartBtn.closest('.zrw-fuel-buybox') ||
            addToCartBtn.closest('[data-custom-buybox]') ||
            addToCartBtn.classList.contains('zrw-checkout-btn')
          ) {
            return;
          }
          if (addToCartBtn.disabled || addToCartBtn.getAttribute('aria-disabled') === 'true') {
            return;
          }
          var form = addToCartBtn.closest('form[action*="/cart/add"]');
          if (form) {
            e.preventDefault();
            var formData = new FormData(form);
            // Disabled <input name="id"> isn't included in FormData. Without an id
            // /cart/add.js silently 404s, so surface the underlying form error
            // (sold-out, unavailable variant, etc.) via product-form's UI instead.
            if (!formData.has('id') || !formData.get('id')) {
              zorawCart.showProductFormError(form, addToCartBtn);
              return;
            }
            zorawCart.addItemFromForm(formData, addToCartBtn);
            return;
          }
        }

      }, true);

      if (this.drawer) {
        // Defense-in-depth: block any click on a +/- button inside a limit-one row,
        // even if the disabled attribute or [data-zoraw-qty] was manipulated.
        this.drawer.addEventListener('click', function(e) {
          var lockedBox = e.target.closest('[data-zoraw-limit-one="true"], .zoraw-qty-box--locked');
          if (lockedBox && e.target.closest('button')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
        }, true);

        this.drawer.addEventListener('click', function(e) {
          if (e.target === zorawCart.drawer) zorawCart.close();
          if (e.target.closest('[data-zoraw-close]')) zorawCart.close();

          var qtyBtn = e.target.closest('[data-zoraw-qty]');
          if (qtyBtn) {
            // Extra safety: if somehow this is inside a locked row, ignore.
            if (qtyBtn.closest('[data-zoraw-limit-one="true"], .zoraw-qty-box--locked')) {
              return;
            }
            var key = qtyBtn.getAttribute('data-item-key');
            var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
            var box = qtyBtn.closest('.zoraw-qty-box');
            if (box) {
              var val = box.querySelector('.zoraw-qty-val');
              if (val) val.innerText = qty;
            }
            zorawCart.performUpdate({ id: key, quantity: qty });
          }

          var bundleDeleteBtn = e.target.closest('[data-zoraw-remove-bundle]');
          if (bundleDeleteBtn) {
            var bundleId = bundleDeleteBtn.getAttribute('data-zoraw-remove-bundle');
            zorawCart.removeBundle(bundleId);
          }

          var addItemBtn = e.target.closest('[data-zoraw-add-item]');
          if (addItemBtn) {
            var variantId = addItemBtn.getAttribute('data-zoraw-add-item');
            zorawCart.addItem(variantId, addItemBtn);
          }

          var toggleUpsellBtn = e.target.closest('[data-zoraw-toggle-upsells]');
          if (toggleUpsellBtn) {
            zorawCart.toggleUpsells();
          }
        });

        this.drawer.addEventListener('change', function(e) {
          var subCheckbox = e.target.closest('[data-zoraw-toggle-sub]');
          if (subCheckbox) {
            var key = subCheckbox.getAttribute('data-item-key');
            var planId = subCheckbox.getAttribute('data-plan-id');
            zorawCart.performUpdate({ id: key, selling_plan: subCheckbox.checked ? parseInt(planId, 10) : '' });
            var wrapper = subCheckbox.closest('.zoraw-sub-wrapper');
            var subOnly = wrapper ? wrapper.querySelectorAll('.zoraw-sub-select, .zoraw-sub-policy-note') : [];
            for (var si = 0; si < subOnly.length; si++) {
              if (subCheckbox.checked) {
                subOnly[si].classList.remove('hidden');
              } else {
                subOnly[si].classList.add('hidden');
              }
            }
          }

          var planSelect = e.target.closest('[data-zoraw-change-plan]');
          if (planSelect) {
            var key = planSelect.getAttribute('data-item-key');
            zorawCart.performUpdate({ id: key, selling_plan: parseInt(planSelect.value, 10) });
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && zorawCart.drawer.classList.contains('open')) {
            zorawCart.close();
          }
        });
      }
    },

    getFocusableElements: function() {
      if (!this.drawer) return [];
      return Array.from(this.drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) {
        return !el.disabled && el.offsetParent !== null;
      });
    },

    trapFocus: function(e) {
      var focusable = zorawCart.getFocusableElements();
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    },

    open: function() {
      this.previousFocus = document.activeElement;
      // Cancel a pending close() cleanup so a rapid close→reopen can't have
      // the old timer re-hide the drawer / unlock the body underneath us.
      clearTimeout(this._closeTimer);
      // Wipe any inline styles left over from a previous close() in case
      // the cleanup timeout never fired (e.g. rapid open→close→open).
      this.drawer.style.background = '';
      this.drawer.style.pointerEvents = '';
      this.drawer.classList.remove('hidden');
      this.drawer.setAttribute('aria-hidden', 'false');

      var self = this;
      setTimeout(function() {
        self.drawer.classList.add('open');
        var closeBtn = self.drawer.querySelector('[data-zoraw-close]');
        if (closeBtn) closeBtn.focus();
      }, 10);

      // The body lock (overflow:hidden) removes the desktop scrollbar, which
      // widens the page and shifts the layout — visible as a "bounce" when the
      // scrollbar returns on close. Reserve the scrollbar's width as body
      // padding for the duration of the lock so the page width never changes.
      // (Measure BEFORE adding the class; 0 on overlay-scrollbar platforms.)
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
      }
      // On mobile the lock makes the body position:fixed, which snaps the
      // document to the top. Remember where the shopper was and shift the
      // body up by the same amount so the page doesn't visibly move; close()
      // restores the real scroll position when it releases the lock.
      this._lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('zoraw-noscroll');
      document.body.style.top = -this._lockedScrollY + 'px';
      document.addEventListener('keydown', this.trapFocus);
    },

    close: function() {
      // Kill the dark backdrop INSTANTLY via inline styles. The opacity
      // transition that used to handle this was unreliable on mobile Safari
      // (sometimes skipped when the address bar shows/hides during the
      // close), leaving the dark overlay stuck on screen until refresh.
      // The drawer container still slides off via its own `right` transition
      // — only the backdrop visual is force-cleared up front.
      this.drawer.style.background = 'transparent';
      this.drawer.style.pointerEvents = 'none';

      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.trapFocus);

      var self = this;
      this._closeTimer = setTimeout(function() {
        self.drawer.classList.add('hidden');
        // Clear inline styles so the next open() inherits the CSS class
        // state cleanly (otherwise background:transparent would persist
        // and the backdrop would never reappear).
        self.drawer.style.background = '';
        self.drawer.style.pointerEvents = '';
        // Body lock released last so iOS doesn't reflow mid-animation.
        // Release the scrollbar-width padding in the same frame the scrollbar
        // returns so the page width stays constant (no close "bounce"), and
        // put the shopper back where they were before the mobile fixed-body
        // lock snapped the document to the top.
        document.body.classList.remove('zoraw-noscroll');
        document.body.style.paddingRight = '';
        document.body.style.top = '';
        window.scrollTo(0, self._lockedScrollY || 0);
      }, 450);

      if (this.previousFocus && this.previousFocus.focus) {
        this.previousFocus.focus();
        this.previousFocus = null;
      }
    },

    refresh: function() {
      // A drawer-initiated mutation (delete, qty change, add) is authoritative and
      // renders the drawer itself — don't start a competing full re-render that could
      // land with a pre-mutation snapshot and undo it.
      if (this._inflight > 0) return;

      var self = this;
      var seq = this._seq;
      fetch(ZR_ROOT + '?sections=' + ZR_SECTION_ID)
        .then(function(res) {
          if (!res.ok) throw new Error('Network error');
          return res.json();
        })
        .then(function(data) {
          // Bail if a mutation started or committed while this refresh was in flight;
          // its render reflects newer cart state than this snapshot.
          if (self._inflight > 0 || self._seq !== seq) return;
          if (data[ZR_SECTION_ID]) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data[ZR_SECTION_ID], 'text/html');
            var newDrawer = doc.getElementById('zoraw-cart-drawer');

            if (newDrawer && zorawCart.drawer) {
              zorawCart.drawer.innerHTML = newDrawer.innerHTML;
            }
            // Keep the header cart badge in sync too — refresh() runs for cart
            // changes made outside the drawer (other add-to-cart surfaces caught
            // by the fetch patch / Dawn pubsub), which otherwise wouldn't update
            // the header count until a page reload.
            var countBubble = doc.getElementById('zoraw-cart-count-bubble');
            if (countBubble) {
              var match = countBubble.textContent.match(/\d+/);
              if (match) self.updateHeaderCartCount(parseInt(match[0], 10));
            }
          }
        })
        .catch(function(err) {
          console.error('Cart refresh error:', err);
        });
    },

    toggleUpsells: function() {
      var container = document.getElementById('zoraw-upsell-items');
      if (!container) return;
      var section = container.closest('.zoraw-upsell-section');
      var toggleBtn = section.querySelector('[data-zoraw-toggle-upsells]');

      if (container.style.display === 'none') {
        container.style.display = 'flex';
        section.classList.add('open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      } else {
        container.style.display = 'none';
        section.classList.remove('open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      }
    },

    // POST a change.js body, reading the response body either way so Shopify's
    // real reason surfaces (e.g. "no valid id or line parameter") instead of a
    // generic message.
    postChange: function(body) {
      return fetch(ZR_ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(res) {
        return res.json().catch(function() { return null; }).then(function(data) {
          if (!res.ok) {
            var desc = (data && (data.description || data.message)) || ('HTTP ' + res.status);
            var err = new Error('Cart update failed: ' + desc);
            err.status = res.status;
            err.body = data;
            throw err;
          }
          return data;
        });
      });
    },

    // Resolve a (possibly stale) line-item key to its CURRENT 1-based line number
    // from the live cart. Returns 0 when it can't be pinned down unambiguously.
    // Needed because cart-mutating apps (e.g. BespokeShipping) append line-item
    // properties after our drawer renders, which changes the line keys and makes
    // change.js reject the key with "no valid id or line parameter".
    resolveLine: function(domKey) {
      return fetch(ZR_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var items = (cart && cart.items) || [];
          // 1) exact key match (fast, unambiguous)
          for (var i = 0; i < items.length; i++) {
            if (items[i].key === domKey) return i + 1;
          }
          // 2) fall back to the variant id (the part before ':' in the key),
          //    but only when exactly one cart line uses that variant — otherwise
          //    we can't tell which line the shopper meant.
          var variantId = String(domKey).split(':')[0];
          var line = 0, count = 0;
          for (var j = 0; j < items.length; j++) {
            var it = items[j];
            if (String(it.variant_id) === variantId ||
                String(it.id) === variantId ||
                String(it.key).split(':')[0] === variantId) {
              count++;
              line = j + 1;
            }
          }
          return count === 1 ? line : 0;
        })
        .catch(function() { return 0; });
    },

    // Signature of the VISIBLE (non-underscore) line-item properties, used to
    // decide whether a new add is "the same thing" as an existing cart line.
    // Underscore properties are ignored on purpose: apps (BespokeShipping)
    // stamp hidden underscore properties onto lines after they're added, which
    // breaks Shopify's native line merging — that's exactly the difference we
    // want to see past.
    visiblePropsSignature: function(props) {
      var keys = [];
      for (var k in props) {
        if (props.hasOwnProperty(k) && k.charAt(0) !== '_') keys.push(k);
      }
      keys.sort();
      var pairs = [];
      for (var i = 0; i < keys.length; i++) {
        pairs.push([keys[i], String(props[keys[i]])]);
      }
      return JSON.stringify(pairs);
    },

    // Shopify only auto-merges /cart/add.js into an existing line when the
    // variant AND every property match exactly, so once an app has stamped
    // hidden properties onto a line, re-adding the same product lands on a
    // second row. Look for a mergeable line first and bump its quantity via
    // change.js instead (by line number — stable even when the app rekeys
    // lines). Resolves with the change.js response when merged, or null when
    // the add should fall through to a normal /cart/add.js.
    tryMergeAdd: function(variantId, qty, sellingPlanId, visibleProps) {
      var self = this;
      var wanted = this.visiblePropsSignature(visibleProps || {});
      var wantedPlan = String(sellingPlanId || '');
      return fetch(ZR_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var items = (cart && cart.items) || [];
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (String(it.variant_id) !== String(variantId)) continue;
            var props = it.properties || {};
            // Bundle member lines must stay their own rows.
            if (props._bundle_id || props.bundle_parent) continue;
            var plan = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan)
              ? String(it.selling_plan_allocation.selling_plan.id) : '';
            if (plan !== wantedPlan) continue;
            if (self.visiblePropsSignature(props) !== wanted) continue;

            var newQty = it.quantity + qty;
            // Sample kit is limited to 1 per order — never grow it past 1.
            if (it.product_id === 7441799741621) newQty = 1;

            return self.postChange({ line: i + 1, quantity: newQty, sections: ZR_SECTION_ID })
              .then(function(data) {
                // Analytics payload: report only the delta that was just added,
                // not the whole (now larger) line.
                var added = {};
                for (var p in it) { if (it.hasOwnProperty(p)) added[p] = it[p]; }
                added.quantity = newQty - it.quantity;
                data.__zorawAdded = added;
                return data;
              });
          }
          return null;
        })
        .catch(function(err) {
          // If the pre-check or the merge itself fails, fall back to a plain
          // add so the customer still gets their item (worst case: the old
          // two-row look for this one add).
          console.warn('zorawCart merge-add fallback:', err);
          return null;
        });
    },

    performUpdate: function(payload) {
      this.setLoading(true);
      var self = this;
      this._inflight++;

      // Resolve the CURRENT line number from the live cart up front, then change
      // by line. BespokeShipping rekeys cart lines after our drawer renders, so
      // the DOM key is almost always stale — sending it first would fire a
      // guaranteed 400 that the browser logs to the console. Resolving first
      // avoids that failed request while still working when the key is fresh
      // (resolveLine's exact-key match handles that case).
      var idKey = payload.id;
      this.resolveLine(idKey)
        .then(function(line) {
          var body = { sections: ZR_SECTION_ID };
          for (var k in payload) {
            if (payload.hasOwnProperty(k) && k !== 'id') body[k] = payload[k];
          }
          // Prefer the resolved line; fall back to the key only if the line
          // couldn't be pinned down (item already gone, or an ambiguous
          // same-variant multi-line cart).
          if (line) { body.line = line; } else { body.id = idKey; }
          return self.postChange(body);
        })
        .then(function(data) {
          self._seq++;
          self.updateDOMFromSections(data.sections[ZR_SECTION_ID]);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zoraw-cart', cartData: data });
          }
        })
        .catch(function(err) {
          console.error('Cart update error:', err, '| sent id:', payload.id, 'qty:', payload.quantity);
          // Last resort: resync the drawer to live cart state so it isn't stuck.
          setTimeout(function() { self.refresh(); }, 0);
        })
        .finally(function() {
          self._inflight--;
          self.setLoading(false);
        });
    },

    updateDOMFromSections: function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var ids = ['zoraw-items-container', 'zoraw-footer-content', 'zoraw-progress-wrapper', 'zoraw-cart-count-bubble'];
      ids.forEach(function(id) {
        var newEl = doc.getElementById(id);
        var currEl = document.getElementById(id);
        if (newEl && currEl) currEl.innerHTML = newEl.innerHTML;
      });

      var countBubble = doc.getElementById('zoraw-cart-count-bubble');
      if (countBubble) {
        var match = countBubble.textContent.match(/\d+/);
        if (match) zorawCart.updateHeaderCartCount(parseInt(match[0], 10));
      }
    },

    updateHeaderCartCount: function(itemCount) {
      var label = itemCount < 100 ? String(itemCount) : '99+';

      // Update any bubbles already in the DOM (Dawn-style bubbles keep the count
      // in an [aria-hidden] child; the custom header bubble holds it directly).
      document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
        var numEl = el.querySelector('[aria-hidden="true"]');
        if (numEl) { numEl.textContent = label; } else { el.textContent = label; }
        el.style.display = itemCount > 0 ? '' : 'none';
      });

      // The custom header renders its bubble only when item_count > 0, so on a
      // cart that started empty there's no node to update — the badge would never
      // appear until a page reload. Ensure every header cart icon has a bubble,
      // creating one on demand.
      document.querySelectorAll('a.icon-btn[data-cart-icon-link]').forEach(function(link) {
        var bubble = link.querySelector('.cart-count-bubble');
        if (!bubble) {
          if (itemCount <= 0) return; // nothing to show; don't add an empty node
          bubble = document.createElement('span');
          bubble.className = 'cart-count-bubble';
          link.appendChild(bubble);
        }
        bubble.textContent = label;
        bubble.style.display = itemCount > 0 ? '' : 'none';
      });
    },

    showProductFormError: function(form, btn) {
      var productForm = form.closest('product-form');
      var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
      var msgEl = wrapper && wrapper.querySelector('.product-form__error-message');
      if (wrapper && msgEl) {
        msgEl.textContent = btn && btn.textContent ? btn.textContent.trim() : 'This product is currently unavailable.';
        wrapper.hidden = false;
        wrapper.toggleAttribute('hidden', false);
      } else if (btn) {
        btn.classList.add('zoraw-btn-shake');
        setTimeout(function() { btn.classList.remove('zoraw-btn-shake'); }, 600);
      }
    },

    notifyAdded: function(addData, cartData) {
      // Standard DOM events many apps listen for
      try {
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: addData, cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
      } catch (e) { /* no-op */ }

      // Dawn internal pubsub (used by Dawn-aware integrations)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zoraw-cart', cartData: cartData });
      }

      // Shopify Web Pixels (Meta CAPI, Klaviyo, TikTok via Shopify pixels, etc.)
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          var items = (addData && addData.items) ? addData.items : (addData ? [addData] : []);
          items.forEach(function(item) {
            if (!item) return;
            window.Shopify.analytics.publish('product_added_to_cart', {
              cartLine: {
                quantity: item.quantity,
                cost: { totalAmount: { amount: (item.line_price || item.final_line_price || item.price || 0) / 100, currencyCode: (cartData && cartData.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' } },
                merchandise: {
                  id: 'gid://shopify/ProductVariant/' + (item.variant_id || item.id),
                  title: item.variant_title || item.title,
                  price: { amount: (item.price || 0) / 100, currencyCode: (cartData && cartData.currency) || 'USD' },
                  product: {
                    id: 'gid://shopify/Product/' + (item.product_id || ''),
                    title: item.product_title || item.title,
                    vendor: item.vendor,
                    type: item.product_type,
                    url: item.url
                  }
                }
              }
            });
          });
        }
      } catch (e) { console.warn('zorawCart analytics publish failed:', e); }
    },

    addItem: function(variantId, btn) {
      if (btn) btn.classList.add('zoraw-btn-loading');

      var self = this;
      this._inflight++;
      // Merge into an existing line when possible (see tryMergeAdd) so a
      // re-added product bumps its quantity instead of creating a second row.
      this.tryMergeAdd(variantId, 1, '', {})
        .then(function(merged) {
          if (merged) return merged;
          return fetch(ZR_ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: ZR_SECTION_ID
            })
          }).then(function(res) {
            return res.json().then(function(data) {
              if (!res.ok) {
                var msg = (data && (data.description || data.message)) || 'Add to cart failed';
                var err = new Error(msg);
                err.payload = data;
                throw err;
              }
              return data;
            });
          });
        })
      .then(function(data) {
        self._seq++;
        self.updateDOMFromSections(data.sections[ZR_SECTION_ID]);
        if (self.drawer.classList.contains('hidden')) {
          self.open();
        }
        // Analytics only — fire-and-forget so it never holds the interaction
        // lock. (Not returned: `.finally` must run as soon as the drawer is
        // rendered/shown, otherwise a slow /cart.js keeps pointer-events off
        // the items and the very next Delete tap gets swallowed.)
        if (data.__zorawAdded) {
          if (data.__zorawAdded.quantity > 0) self.fetchCartThenNotify({ items: [data.__zorawAdded] });
        } else {
          self.fetchCartThenNotify(data);
        }
      })
      .catch(function(err) {
        console.error('Add item error:', err);
      })
      .finally(function() {
        self._inflight--;
        if (btn) btn.classList.remove('zoraw-btn-loading');
      });
    },

    // Pull the full cart JSON (for analytics payloads) and notify listeners.
    // Intentionally detached from the add flow's promise chain — a hang or
    // failure here must not leave the drawer in its loading (pointer-events:
    // none) state.
    fetchCartThenNotify: function(addData) {
      var self = this;
      fetch(ZR_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cartData) { self.notifyAdded(addData, cartData); })
        .catch(function() { /* analytics best-effort */ });
    },

    addItemFromForm: function(formData, btn) {
      formData.append('sections', ZR_SECTION_ID);
      if (!formData.has('quantity')) {
        formData.append('quantity', 1);
      }

      this.setLoading(true);
      if (btn) btn.classList.add('zoraw-btn-loading');

      // Pull out what tryMergeAdd needs to find an existing line for this add.
      var variantId = formData.get('id');
      var qty = parseInt(formData.get('quantity'), 10) || 1;
      var sellingPlan = formData.get('selling_plan') || '';
      var visibleProps = {};
      var hasHiddenProps = false;
      formData.forEach(function(value, name) {
        var m = name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        if (m[1].charAt(0) === '_') { hasHiddenProps = true; } else { visibleProps[m[1]] = value; }
      });

      var self = this;
      this._inflight++;
      // Adds that carry their own hidden properties (bundle flows etc.) are
      // intentional new lines — never merge those.
      var mergeAttempt = hasHiddenProps
        ? Promise.resolve(null)
        : this.tryMergeAdd(variantId, qty, sellingPlan, visibleProps);

      mergeAttempt
        .then(function(merged) {
          if (merged) return merged;
          return fetch(ZR_ROOT + 'cart/add.js', {
            method: 'POST',
            body: formData
          }).then(function(res) {
            return res.json().then(function(data) {
              if (!res.ok) {
                var msg = (data && (data.description || data.message)) || 'Add to cart failed';
                var err = new Error(msg);
                err.payload = data;
                err.status = res.status;
                throw err;
              }
              return data;
            });
          });
        })
      .then(function(data) {
        self._seq++;
        self.updateDOMFromSections(data.sections[ZR_SECTION_ID]);
        self.open();
        // Analytics only — fire-and-forget so the loading lock (pointer-events:
        // none on the items) releases the instant the drawer is shown, not after
        // this trailing request. Otherwise the Delete tap right after the drawer
        // opens is swallowed until the page is reloaded.
        if (data.__zorawAdded) {
          if (data.__zorawAdded.quantity > 0) self.fetchCartThenNotify({ items: [data.__zorawAdded] });
        } else {
          self.fetchCartThenNotify(data);
        }
      })
      .catch(function(err) {
        console.error('Add from form error:', err);
        // Surface error in product-form UI when possible (validation, sold-out, etc.)
        var form = btn ? btn.closest('form[action*="/cart/add"]') : null;
        if (form) {
          var productForm = form.closest('product-form');
          var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
          var msgEl = wrapper && wrapper.querySelector('.product-form__error-message');
          if (wrapper && msgEl) {
            msgEl.textContent = err.message || 'Could not add to cart.';
            wrapper.hidden = false;
            wrapper.toggleAttribute('hidden', false);
          }
        }
      })
      .finally(function() {
        self._inflight--;
        self.setLoading(false);
        if (btn) btn.classList.remove('zoraw-btn-loading');
      });
    },

    removeBundle: function(bundleId) {
      this.setLoading(true);

      var self = this;
      this._inflight++;
      fetch(ZR_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(cartData) {
          var updates = {};
          cartData.items.forEach(function(item) {
            if (item.properties && item.properties['_bundle_id'] === bundleId) {
              updates[item.key] = 0;
            }
          });

          return fetch(ZR_ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates, sections: ZR_SECTION_ID })
          });
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Bundle removal failed');
          return res.json();
        })
        .then(function(data) {
          self._seq++;
          self.updateDOMFromSections(data.sections[ZR_SECTION_ID]);
        })
        .catch(function(err) {
          console.error('Remove bundle error:', err);
        })
        .finally(function() {
          self._inflight--;
          self.setLoading(false);
        });
    }
  };

  window.zorawCart = zorawCart;
  zorawCart.init();

  } catch(e) { console.error(e); }
})();
})();
